import { Pipe, PipeTransform } from '@angular/core';
import { CertificateDto } from 'src/app/models/trofaco/certificateDto';

@Pipe({
  name: 'totalCertificatesTree'
})
export class TotalCertificatesTreePipe implements PipeTransform {

    transform(value: CertificateDto[]): number {
        if (!value) return;
        const totalTrees = value.reduce((sum, current) => sum + current.count, 0);
        return totalTrees;
    }

}
